var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_2167",
  "data-name": "Group 2167",
  transform: "translate(-2050 803)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_274",
  "data-name": "Rectangle 274",
  width: 16,
  height: 16,
  rx: 2,
  transform: "translate(2050 -803)",
  fill: "#c62626"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2166",
  "data-name": "Group 2166",
  transform: "translate(-1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_97",
  "data-name": "Path 97",
  d: "M.657,0,0,10.657",
  transform: "translate(2062.5 -798.5) rotate(45)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_98",
  "data-name": "Path 98",
  d: "M.657,10.657,0,0",
  transform: "translate(2062.965 -790.964) rotate(135)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1.5
})))));
export default __webpack_public_path__ + "static/media/attcross.7f09c88e.svg";
export { SvgComponent as ReactComponent };